import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({

	imports: [
		CommonModule,
		NgbModule,
	],
	exports: [
		CommonModule,
		NgbModule,
	],
	providers: [
	]
})
export class SharedModule {}
